import React from "react";
import AlgoFilters from "./AlgoFilter";
import AlgoStrategies from "./AlgoStrategies";

function Marketplace() {
  return (
    <main>
      {/* Breadcrumb Section */}
      <section className="page_breadcrumb" data-aos="fade-up">
        <div className="container">
          <div className="breadcrumb_content centred">
            <h1 className="breadcrumb_title">Marketplace</h1>
            <ul className="breadcrumb_menu">
              <li>
                <a href="/">Home</a>
              </li>
              <li>/</li>
              <li>Marketplace</li>
            </ul>
          </div>
        </div>
      </section>

      {/* AlgoFilter + AlgoStrategies Section */}
      <section className="blog_section">
        <div className="container">
          <div class="section_title">
            <h2>Discover Strategy</h2>
            <p>
              If the value of either Profit Target or Max Loss is set to 0, that
              will be considered as having no limit.
            </p>
          </div>
          <div className="row">
            {/* Left Column - Filters */}
            <div className="col-xl-3 col-lg-3 col-md-12">
              <AlgoFilters />
            </div>

            {/* Right Column - Strategies */}
            <div className="col-xl-9 col-lg-9 col-md-12">
              <AlgoStrategies />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Marketplace;
